import { noop } from '../../utils/function'

export const resetSubStores = noop
